import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import './OuterBox.scss';

export const OuterBox = ({ children, className }) => {
  const classes = classnames('outer-box', {
    [`${className}`]: !!className,
  });
  return <div className={classes}>{children}</div>;
};

OuterBox.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
OuterBox.defaultProps = {
  className: '',
};
